import { render, staticRenderFns } from "./BtnRetornarFinalizacao.vue?vue&type=template&id=738babb4"
import script from "./BtnRetornarFinalizacao.vue?vue&type=script&lang=js"
export * from "./BtnRetornarFinalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports